function StorageUtil() {

    const _this = this;

    this.get = function (key) {
        if (_this.contains(key)) {
            return localStorage.getItem(key);
        } else {
            return null;
        }
    };

    this.set = function (key, data) {
        return localStorage.setItem(key, data);
    };

    this.remove = function (key) {
        localStorage.removeItem(key);
    };

    this.contains = function (key) {
        return localStorage.hasOwnProperty(key);
    };

    this.key = function (index) {
        return localStorage.key(index);
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    this.clearAll = function () {
        return localStorage.clear();
    };

    this.clearCache = function () {
        for (const key in localStorage) {
            if (key !== "userData") {
                localStorage.removeItem(key);
            }
        }
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    this.setObject = function (key, object) {
        return localStorage.setItem(key, JSON.stringify(object));
    };

    this.getObject = function (key) {
        if (_this.contains(key)) {
            try {
                return JSON.parse(localStorage.getItem(key));
            } catch (e) {
                return null;
            }
        } else {
            return null;
        }
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    this.setObjectAttr = function (key, attrName, attrValue) {
        let object = _this.getObject(key);
        if (object === null) {
            object = {};
        }
        object[attrName] = attrValue;
        _this.setObject(key, object);
    };

    this.getObjectAttr = function (key, attrName) {
        if (_this.contains(key)) {
            let object = _this.getObject(key);
            if (object) {
                return object[attrName];
            }
        }
        return null;
    };

    this.removeObjectAttr = function (key, attrName) {
        if (_this.contains(key)) {
            let object = _this.getObject(key);
            if (object) {
                delete object[attrName];
            }
        }
    };

    this.containsObjectAttr = function (key, attrName) {
        if (_this.contains(key)) {
            let object = _this.getObject(key);
            if (object) {
                return object.hasOwnProperty(attrName);
            }
        }
        return false;
    };
}

export default new StorageUtil();